import { promisifyConfirm, ConfirmResult, promisifyAlert, AlertResult } from './alertifyPromise';
import * as alertify from 'alertifyjs';

export default class PopupHelper {
  static dobMismatchHelper(): Promise<ConfirmResult> {
    const message = `
    <div class="dob-mismatch-container">
      <div class="dob-mismatch-message">The applicant DOB does not match the court DOB.</div>
      <div>Select <span class="highlight">Proceed</span> to continue without editing the DOB.</div>
      <div>Select <span class="highlight">Update</span> to edit the DOB.</div>
    </div>
    `;
    return promisifyConfirm('<div class="red dbo-title">***WARNING*** DOB MISMATCH</div>', message, {
      labels: {
        ok: 'Proceed',
        cancel: 'Update'
      }
    });
  }

  static saveUnsavedChangesHelper(): Promise<ConfirmResult> {
    const message = `You made changes to the current record.
    <br><br>If you would like these changes to be saved, please select <b>Cancel</b> and Save Record.
    Select <span class="highlight">OK</span> to proceed without saving these changes`;
    return promisifyConfirm('<span class="highlight">Unsaved changes</span>', message);
  }

  static exitSystemHelper(): Promise<ConfirmResult> {
    const message = `You have chosen to Exit the Criminal Research System. If you
    have made any changes that you have not saved, please select
    the <span class="highlight">CANCEL</span> push-button to save those changes. To continue
    logging off of the system, select the <span class="highlight">OK</span> push-button.`;
    return promisifyConfirm('<span class="highlight">System Exit</span>', message);
  }
  static confirmSubmitHelper(message: string): Promise<ConfirmResult> {
    return promisifyConfirm('<span class="highlight">Confirm Submit</span>', message);
  }
  static pendingWOHelper(message: string): Promise<AlertResult> {
    return promisifyAlert('<span class="highlight">Crim System</span>', message);
  }
  static passwordExpirationHelper(message: string): Promise<ConfirmResult> {
    return promisifyConfirm('<span class="highlight">Crim Error</span>', message);
  }
  static saveComment(message: string): Promise<AlertResult> {
        return promisifyAlert('<span class="highlight">Notice</span>', message);
  }
  static loginIssue(message: string): Promise<AlertResult> {
    return promisifyAlert('<span class="highlight">CrimSystem</span>', message);
  }
  static userHelperConfirm(message: string): Promise<ConfirmResult> {
    return promisifyConfirm('<span class="highlight">Crim System</span>', message);
  }
  static userHelper(message: string, type: string): Promise<AlertResult> {
    if (type === 'error') {
        return promisifyAlert('<span class="highlight">Crim Error</span>', message);
    } else if (type === 'crim') {
      return promisifyAlert('<span class="highlight">Crim System</span>', message);
    } else {
      return promisifyAlert('<span class="highlight">Forgot Password</span>', message);
    }
  }
  static deleteRecordHelper(): Promise<ConfirmResult> {
    const message = `Are you sure you want to delete this record?`;
    return promisifyConfirm('<span class="highlight">Record Delete</span>', message);
  }

  static systemVersion() {
    alertify.alert('Crim System', `Criminal Record Information Management Version 2.0`);
  }

  static support() {
    alertify.alert('Crim System', `Please contact GIS Vendor Relations for any questions related to CRIM.`);
  }

  static submitHelper(message) {
    alertify.alert('Crim System', message);
  }
  static noChangesToTaskList(): Promise<AlertResult> {
    return promisifyAlert('<span class="highlight">Crim System</span>', `No Changes have been made to the Task List.`);
  }
  static noHitsConfirmation(message: string): Promise<ConfirmResult> {
    return promisifyConfirm('<span class="highlight">Crim System</span>', message);
  }
  static developerEasterEgg() {
    alertify.alert('Easter Egg Found!!!',
      `
      <div style="align-content: center; text-align: center;">
        <h1 style="font-size: 1rem; margin-bottom: 1rem;">Here are the members of the CRIM team in late 2017</h1>
        <h1 style="font-size: 1rem;">Director</h1>
        <div>Kristin Schaefer</div>

        <h1 style="font-size: 1rem;">Manager</h1>
        <div style="margin-bottom: 1rem;">Steve Amodio</div>

        <h1 style="font-size: 1rem;">Product Owner</h1>
        <div>Todd Francis</div>

        <h1 style="font-size: 1rem;">Qa Team</h1>
        <div>Kavitha Jayaseelan</div>
        <div>Lindsey Fletcher</div>
        <div>Mohana Katukuti</div>

        <h1 style="font-size: 1rem;">Front-end Developers</h1>
        <div>Tracy Carter-Romey</div>
        <div>Michael Astrauckas(Best Developer Ever!!!)</div>

        <h1 style="font-size: 1rem;">Back-end Developers</h1>
        <div>Rob Segal</div>
        <div style="margin-bottom: 3rem;">Michael Baffey</div>
        <div style="font-size: 0.001rem;">
          01000011 01110010 01101001 01101101
          00100000 01101001 01110011 00100000
          01101110 01101111 01110100 00100000
          01100001 00100000 01010011 01110100
          01110010 01100001 01110100 01110101
          01110011 00100000 01110000 01110010
          01101111 01101010 01100101 01100011
          01110100 00100001
        </div>
      </div>
      `);
  }
}



// WEBPACK FOOTER //
// ./src/models/popupHelper.ts